import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { messages } from '@/i18n';

/**
 * An offline user cannot obtain a token, so the app must say "no connection"
 * rather than surfacing an auth error — the two have completely different
 * remedies and only one of them is the user's to apply.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      className="bg-warning/20 border-warning/40 text-foreground flex items-center gap-2 border-b px-4 py-2 text-sm md:px-8"
    >
      <WifiOff className="size-4 shrink-0" aria-hidden />
      <span className="font-medium">{messages.offline.title}</span>
      <span className="text-muted-foreground hidden sm:inline">{messages.offline.body}</span>
    </div>
  );
}
